import React from 'react'
import styled from 'styled-components'

import SquareLogo from './blb-square-logo'

const StyledHeader = styled.header`
   margin-left: 5vw;
   padding-top: 0.5rem;
   padding-bottom: 0.5rem;
   display: flex;
   align-items: center;
`

const StyledText = styled.span`
   margin-left: 10px;
   font-size: 0.8em;
   font-family: 'Righteous', serif;
   color: var(--text-color-inverted);
`

const Header = ({ text = 'engineering | consultancy' }) => (
   <StyledHeader>
      <SquareLogo />
      <StyledText>{text}</StyledText>
   </StyledHeader>
)

export default Header
